<template>
  <main id="js-page-content" role="main" class="page-content">
    <ol class="breadcrumb page-breadcrumb">
      <li class="breadcrumb-item">
        <a href="javascript:void(0);">SmartAdmin</a>
      </li>
      <li class="breadcrumb-item">Category</li>
      <li class="breadcrumb-item">Sub-category</li>
      <li class="breadcrumb-item active">Page Title</li>
      <li class="position-absolute pos-top pos-right d-none d-sm-block">
        <span class="js-get-date"></span>
      </li>
    </ol>
    <div class="subheader">
      <h1 class="subheader-title">
        <i class="subheader-icon fal fa-globe"></i> Loader
        <span class="fw-300">サンプル</span>
        <sup class="badge badge-primary fw-500">STICKER</sup>
        <small> Insert page description or punch line </small>
      </h1>
      <!-- 
		Right content on content header
		A nice area to add graphs or buttons -->
      <div class="subheader-block">Right Subheader Block</div>
    </div>

    <div class="alert alert-primary">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i
              class="base base-6 icon-stack-3x opacity-100 color-primary-500"
            ></i>
            <i
              class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
            ></i>
            <i
              class="ni ni-blog-read icon-stack-1x opacity-100 color-white"
            ></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">注意事項!</span>
            <p>特に注意事項はないです</p>
            <p class="m-0">
              Follow a slogal with a useful link or call to action
              <a href="#" target="_blank">Call to action >></a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>button</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a href="#" class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel"
                    >Refresh Content</span
                  ></a
                >
                <a href="#" class="dropdown-item js-panel-locked"
                  ><span data-i18n="drpdwn.lockpanel">Lock Position</span></a
                >
                <div class="dropdown-multilevel dropdown-multilevel-left">
                  <div class="dropdown-item">
                    <span data-i18n="drpdwn.panelcolor">Panel Style</span>
                  </div>
                  <div
                    class="dropdown-menu d-flex flex-wrap"
                    style="min-width: 9.5rem; width: 9.5rem; padding: 0.5rem"
                  >
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-700 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-500 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-500 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-600 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-600 bg-primary-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-600 bg-primray-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-600 bg-primray-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-600 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-600 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-700 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-900 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-700 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-700 bg-primary-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-600 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-600 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-danger-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-danger-900 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-fusion-400 bg-fusion-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-fusion-400 bg-fusion-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-faded width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-faded"
                      style="margin: 1px"
                    ></a>
                  </div>
                </div>
                <div class="dropdown-divider m-0"></div>
                <a href="#" class="dropdown-item js-panel-reset"
                  ><span data-i18n="drpdwn.resetpanel">Reset Panel</span></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    ボタンを押すとボタンが無効になり、処理が終わると再度ボタンが有効になる。
                  </div>

                  <button
                    @click="showLoader()"
                    id="btn1"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    処理実行
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>panel</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
            <div class="panel-toolbar" role="menu">
              <a
                href="#"
                class="btn btn-toolbar-master waves-effect waves-themed"
                data-toggle="dropdown"
                ><i class="fal fa-ellipsis-v"></i
              ></a>
              <div
                class="dropdown-menu dropdown-menu-animated dropdown-menu-right p-0"
              >
                <a href="#" class="dropdown-item js-panel-refresh"
                  ><span data-i18n="drpdwn.refreshpanel"
                    >Refresh Content</span
                  ></a
                >
                <a href="#" class="dropdown-item js-panel-locked"
                  ><span data-i18n="drpdwn.lockpanel">Lock Position</span></a
                >
                <div class="dropdown-multilevel dropdown-multilevel-left">
                  <div class="dropdown-item">
                    <span data-i18n="drpdwn.panelcolor">Panel Style</span>
                  </div>
                  <div
                    class="dropdown-menu d-flex flex-wrap"
                    style="min-width: 9.5rem; width: 9.5rem; padding: 0.5rem"
                  >
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-700 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-500 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-500 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-primary-600 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-primary-600 bg-primary-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-600 bg-primray-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-600 bg-primray-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-600 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-600 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-info-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-info-700 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-900 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-700 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-700 bg-primary-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-success-600 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-success-600 bg-success-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-danger-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-danger-900 bg-info-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-fusion-400 bg-fusion-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-fusion-400 bg-fusion-gradient"
                      style="margin: 1px"
                    ></a>
                    <a
                      href="#"
                      class="btn d-inline-block bg-faded width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed"
                      data-panel-setstyle="bg-faded"
                      style="margin: 1px"
                    ></a>
                  </div>
                </div>
                <div class="dropdown-divider m-0"></div>
                <a href="#" class="dropdown-item js-panel-reset"
                  ><span data-i18n="drpdwn.resetpanel">Reset Panel</span></a
                >
              </div>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    ボタンを押すとパネル単位のローダーを表示して、処理を開始し、処理が完了するとローダーを消す。
                  </div>

                  <button
                    @click="showLoader4panel()"
                    id="btn2"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    処理実行
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";

@Options({})
export default class Loader extends Vue {
  /**
   * 基本の処理の形。処理中はボタン押下は無効になる。
   *
   */
  async showLoader(): Promise<void> {
    //ボタンを無効化
    //-----------------
    const btn = document.getElementById("btn1");
    btn?.setAttribute("disabled", "disabled");

    try {
      //処理
      Cl_common.logger("処理実行");
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //ボタンを無効解除
      //-----------------
      btn?.removeAttribute("disabled");
    }
  }
  /**
   * 基本の処理の形2。パネルにローダーを表示。
   * ローダーの入ったパネルである必要があるので注意。
   *
   */
  async showLoader4panel(): Promise<void> {
    //ローダー表示※必ずしもボタンからたどる必要はない。
    //-----------------
    const panel = document.getElementById("btn2")?.closest(".panel-container");
    panel?.classList.add("enable-loader");

    try {
      //処理
      Cl_common.logger("処理実行");
    } catch (error) {
      Cl_common.logger(error);
    } finally {
      //ローダー非表示
      //-----------------
      panel?.classList.remove("enable-loader");
    }
  }
}
</script>
